import { render, staticRenderFns } from "./ResourceGroup.vue?vue&type=template&id=4a60a892&scoped=true&"
import script from "./ResourceGroup.vue?vue&type=script&lang=js&"
export * from "./ResourceGroup.vue?vue&type=script&lang=js&"
import style0 from "./ResourceGroup.vue?vue&type=style&index=0&id=4a60a892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60a892",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
